import { render, staticRenderFns } from "./expenseDetails1.vue?vue&type=template&id=90a4ea9c&"
import script from "./expenseDetails1.vue?vue&type=script&lang=js&"
export * from "./expenseDetails1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports